import { enDictionary } from './en';
import { jaDictionary } from './ja';
import { krDictionary } from './kr';
import { zhCNDictionary } from './zh-CN';
import { zhTWDictionary } from './zh-TW';
export { jaDictionary, enDictionary, krDictionary, zhCNDictionary, zhTWDictionary };
export const dictionaries = {
    ja: jaDictionary,
    en: enDictionary,
    kr: krDictionary,
    'zh-CN': zhCNDictionary,
    'zh-TW': zhTWDictionary,
};
